export default "__VITE_ASSET__DA_4D5yL__"